import { render, staticRenderFns } from "./YA_Login.vue?vue&type=template&id=650bd4d1&scoped=true"
import script from "./YA_Login.vue?vue&type=script&lang=js"
export * from "./YA_Login.vue?vue&type=script&lang=js"
import style0 from "./YA_Login.vue?vue&type=style&index=0&id=650bd4d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650bd4d1",
  null
  
)

export default component.exports